import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getPublicServerData } from '../Service/GetDataApi'

// Pages are matched by Title with "-" standing in for spaces (see Home.js decodeURLString),
// so the stored href (which contains raw spaces) cannot be used as a route.
const toRoute = (title) => `/${String(title).trim().replace(/\s+/g, '-')}`;

const socialKey = (title) => String(title).toLowerCase().replace(/[^a-z]/g, '');

const SOCIAL_CLASS = {
  facebook: "rounded-circle si-borderless si-facebook si-small social-icon",
  linkedin: "social-icon si-small si-borderless si-linkedin",
};

const SOCIAL_ICON = {
  facebook: "icon-facebook",
  linkedin: "icon-linkedin",
};

export default function Footer() {
  const [FooterData, setFooterData] = useState([]);
  useEffect(() => {
    GetAllFooterData('Footer');
  }, []);

  const GetAllFooterData = async (tableName) => {
    const footerData = await getPublicServerData(tableName);
    setFooterData(footerData)
  };

  const byType = (type) =>
    FooterData
      .filter((item) => String(item.FooterTaxType || '').trim() === type)
      .sort((a, b) => Number(a.SortOrder || 0) - Number(b.SortOrder || 0));

  const brand = byType('Brand Name')[0];
  const address = byType('Address')[0];
  const email = byType('Email')[0];
  const phone = byType('Phone')[0];
  const socialLinks = byType('Social Media Link');
  const bottomNav = byType('Bottom Navigation');
  const copyright = byType('Copy Write Text')[0];

  return (
    <div id="footer" className="pb-3" style={{ marginBottom: "0px !important" }}>
      <div id="copyrights">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-4 text-center text-md-left">
              <address className="mb-0">
                <strong>{brand?.Title?.trim()}</strong>
                <br />
                <span>{address?.Title?.trim()}</span>
              </address>
            </div>
            <div className="col-md-4 text-center text-md-left">
              <div className="divider divider-center">
                <div className="social-icon-box">
                  {socialLinks.map((item) => {
                    const key = socialKey(item.Title);
                    const icon = SOCIAL_ICON[key] || "icon-link";
                    return (
                      <a
                        key={item.id}
                        href={item.href}
                        className={SOCIAL_CLASS[key] || "social-icon si-small si-borderless"}
                      >
                        <i className={icon}></i>
                        <i className={icon}></i>
                      </a>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="col-md-4 text-center text-md-right">
              <p>
                {email && (
                  <a href={`mailto:${email.Title.trim()}`}>
                    <i className="icon-envelope"></i>{email.Title}
                  </a>
                )}
              </p>
              <div className="clear"></div>
              <p className="mb-0">
                {phone && (
                  <a href={`tel:${phone.Title.replace(/[^\d+]/g, '')}`}>
                    <i className="icon-phone"></i>{phone.Title}
                  </a>
                )}
              </p>
            </div>
          </div>
          <div className="clear"></div>
          <div className="row mt-5">
            <div className="col-md-4 copyright-links justify-content-md-start">
              {bottomNav.map((item, index) => (
                <React.Fragment key={item.id}>
                  {index > 0 && " / "}
                  <Link to={toRoute(item.Title)}>{item.Title.trim()}</Link>
                </React.Fragment>
              ))}
            </div>
            <div className="col-md-4 d-flex justify-content-center">
              {copyright?.Title?.trim()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
